import { baseLoader } from './baseLoader';
import { getAllObjections } from 'src/services/getAllObjections';
import { getObjectionsTypes } from 'src/services/getObjectionsTypes';
import { getQueryParams } from 'src/utils/helpers/queryParams';
import { parseSort } from 'src/hooks/filters/useSort';
import { parseFilters } from 'src/hooks/filters/useFilters';

export const getObjectionsLoader = ({ request }) => {
	const { limit, page } = getQueryParams({ request }, ['page', 'limit']);
	const params = new URL(request.url).searchParams;

	return baseLoader(async () => {
		const [objections, types] = await Promise.all([
			getAllObjections({
				page: Number(page) || 1,
				limit: Number(limit) || 15,
				sort: parseSort(params),
				filters: parseFilters(params),
			}),
			getObjectionsTypes(),
		]);

		return {
			...objections,
			objectionTypes: types.items ?? types,
		};
	}, 'Failed to load all objections.', request);
};
